import { Injectable } from '@angular/core';
import { Subject, ReplaySubject, Observable } from 'rxjs'
import { CoordCampo } from '../interfaces/varias-interfaces';
import { RespuestaPlacetopay } from '../interfaces/empresa-interfaces';
import { LogService } from "../servicios/log-servicios";

@Injectable({
  providedIn: 'root'
})
export class MuestraService {
  constructor(
    private logService: LogService
  ) { }

  //Offline: muestra un pequeño recuadro con texto y/o gráfico indicando q está fuera de línea.
  //Se activa al llamar muestraOffline(true), se cierra al llamar muestraOffline(false) cuando está otra vez Online
  private offline_ = new Subject<boolean>();
  offline$ = this.offline_.asObservable();

  muestraOffline(vf: boolean) {
    //uso este timeout, ver explicación en Loading
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mOff next');
      this.offline_.next(vf);
    })
  }

  //Loading: muestra un spinner cuando se espera que algo se demore.
  //Se activa al llamar muestraLoading(true), se cierra al llamar muestraLoading(false) cuando la tarea larga termina
  private loading_ = new Subject<boolean>();
  loading$ = this.loading_.asObservable();

  muestraLoading(vf: boolean) {
    //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError, que ocurre al
    //poner un loading al cargar InicioCom. El sitio-usuario (o admin).component.html evalúa la 
    //var local muestraLoading que el .ts puso en false y da inicialmente false, pero enseguida se carga el InicioCom 
    //y pone muestraLoading en true, todo dentro del ciclo normal de carga de la página. El timeout hace que 
    //el cambio a true demore un poco y salga del ciclo de carga, y deja de salir el error.
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mLoad next');
      this.loading_.next(vf);
    })
  }

  //Msgbox: muestra un diálogo modal pequeño para comunicar algo al usuario y pedir su respuesta.
  //Se activa al llamar muestraMsgbox(5 parámetros), 
  //se cierra al dar clic en uno de los botones que llama a ocultaMsgbox(1 parám)
  //recibe parámetros desde la llamada e informa
  mbTitulo: string = '';
  mbTexto1: string = '';
  mbTexto2: string = '';
  mbBotones: string = '';
  mbIcono: string = '';
  mbRespuesta: string = '';
  //contador: number = 1;   //para ver si genera un nuevo valor del observable (ok) o mostraba el mismo (mal)

  private msgbox_ = new ReplaySubject<boolean>(1, 100);
  msgbox$ = this.msgbox_.asObservable();
  private msgboxRespuesta_ = new ReplaySubject<string>(1, 100);
  msgboxRespuesta$ = this.msgboxRespuesta_.asObservable();

  muestraMsgbox(pTtl: string, pTx1: string, pTx2: string, pBtn: string, pIco: string): Observable<string> {
    //muestra el msgbox, los parámetros indican lo que se debe mostrar, todos son obligatorios
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mMb');
    this.mbTitulo = pTtl != undefined ? pTtl : 'Mensaje';
    this.mbTexto1 = pTx1 != undefined ? pTx1 : 'Mensaje';
    this.mbTexto2 = pTx2 != undefined ? pTx2 : '';
    this.mbBotones = pBtn != undefined ? pBtn : 'Ok';
    this.mbIcono = pIco != undefined ? pIco : '';
    this.mbRespuesta = '';
    //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError, que ocurre porque en
    //una prueba puse un msgbox al cargar InicioCom. El sitio-usuario (o admin).component.html evalúa la 
    //var local muestraMsgbox que el .ts puso en false y da inicialmente false, pero enseguida se carga el InicioCom 
    //y pone muestraMsgbox en true, todo dentro del ciclo normal de carga de la página. El timeout hace que 
    //el cambio a true demore un poco y salga del ciclo de carga, y deja de salir el error.
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mMb next true');
      this.msgbox_.next(true);
    })
    return this.msgboxRespuesta$;
  }

  ocultaMsgbox(resp: string) {
    //cierra el msgbox, el único parámetro indica el botón respondido
    this.logService.consoleLog('2', 'CS MS oMb');
    this.mbRespuesta = resp != undefined ? resp : 'ATENCION!';
    this.mbTitulo = '';
    this.mbTexto1 = '';
    this.mbTexto2 = '';
    this.mbBotones = '';
    this.mbIcono = '';
    //pongo el timeout también al cerrar el msgbox
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS oMb next false');
      this.msgbox_.next(false);
      if (resp != '') {
        //genero también el evento de la respuesta
        this.msgboxRespuesta_.next(this.mbRespuesta); // + this.contador
        //this.contador += 1;
      }
    })
  }

  //Pictake: muestra un diálogo modal pequeño para tomar una foto y si es adecuada, grabarla en una ruta.
  //Se activa al llamar muestraPictake(3 parámetros), 
  //se cierra al dar clic en botón Salir
  //recibe parámetros desde la llamada e informa
  ptTitulo: string = '';
  //ptRuta:string = '';

  //el observable boolean pictake$ indica si debe verse u ocultarse el diálogo pictake
  private pictake_ = new ReplaySubject<boolean>(1, 100);
  pictake$ = this.pictake_.asObservable();
  //Al llamar a muestraPictake el Caller envía un id. Al tomarse la foto, notificaPictake envía el id del Caller
  //en el observable string pictakeCallerId$ a todos los suscriptores. Solo el suscriptor q tenga el id correcto 
  //será el Caller, y solo ese suscriptor procesará la imagen como corresponda.
  //En el caso de consultas, el id es el cid de la consulta, solo una consulta llama al pictake en cada instante
  pictakeCallerId: string = '';
  private pictakeCallerId_ = new ReplaySubject<string>(1, 100);
  pictakeCallerId$ = this.pictakeCallerId_.asObservable();
  //para cerrar el subscribe q estaba activo al cerrar el pictake
  private onPictakeClose_ = new ReplaySubject<void>(1, 100);
  onPictakeClose$ = this.onPictakeClose_.asObservable();

  //la variable string ptFoto contiene la foto q se acaba de tomar
  ptFoto: string = '';
  ptObserv: string = '';
  ptUnaVarias: string = '';

  muestraPictake(callerId: string, pTit1: string, pUnaVarias: string) {     //, pUnaVarias:string
    //muestra el pictake, los parámetros indican el callerId, título y si puede tomar 1 o varias, todos son obligatorios
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mPt');
    this.ptTitulo = pTit1 != undefined ? pTit1 : 'Mensaje';
    this.pictakeCallerId = callerId;
    this.ptUnaVarias = pUnaVarias;
    //this.ptRuta = pRuta1 != undefined ? pRuta1 : 'imgs';
    //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mPt next true');
      this.pictake_.next(true);
    })
  }

  notificaPictake(img: string, observ: string) {
    //notifica a todos los suscriptores cuando se toma una foto, envía el callerId para que c/suscriptor decida si es para él.
    //graba dos variables this.ptFoto con la img y this.ptObserv con la observación para q el suscriptor correcto haga algo
    this.logService.consoleLog('2', 'CS MS notificaPt');
    this.ptFoto = img;
    this.ptObserv = observ;
    this.pictakeCallerId_.next(this.pictakeCallerId);
  }

  ocultaPictake() {
    //cierra el pictake
    this.logService.consoleLog('2', 'CS MS oPt');
    this.ptTitulo = '';
    //this.ptRuta = '';
    //pongo el timeout también al cerrar el pictake
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS oPt next false');
      this.pictake_.next(false);
      this.onPictakeClose_.next();
    })
  }

  //Picload: muestra un diálogo modal pequeño para tomar una foto y si es adecuada, grabarla en una ruta.
  //Se activa al llamar muestraPicload(3 parámetros), 
  //se cierra al dar clic en botón Salir
  //recibe parámetros desde la llamada e informa
  plTitulo: string = '';
  //plRuta:string = '';

  //el observable boolean picload$ indica si debe verse u ocultarse el diálogo picload
  private picload_ = new ReplaySubject<boolean>(1, 100);
  picload$ = this.picload_.asObservable();
  //Al llamar a muestraPicload el Caller envía un id. Al tomarse la foto, notificaPicload envía el id del Caller
  //en el observable string picloadCallerId$ a todos los suscriptores. Solo el suscriptor q tenga el id correcto 
  //será el Caller, y solo ese suscriptor procesará la imagen como corresponda.
  //En el caso de consultas, el id es el cid de la consulta, solo una consulta llama al picload en cada instante
  picloadCallerId: string = '';
  private picloadCallerId_ = new ReplaySubject<string>(1, 100);
  picloadCallerId$ = this.picloadCallerId_.asObservable();
  //para cerrar el subscribe q estaba activo al cerrar el picload
  private onPicloadClose_ = new ReplaySubject<void>(1, 100);
  onPicloadClose$ = this.onPicloadClose_.asObservable();

  //la variable string plFoto contiene la foto q se acaba de tomar
  plFoto: string = '';
  plObserv: string = '';
  plUnaVarias: string = '';

  muestraPicload(callerId: string, pTit1: string, pUnaVarias: string) {     //, pUnaVarias:string
    //muestra el picload, los parámetros indican el callerId, título y si puede tomar 1 o varias, todos son obligatorios
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mPl');
    this.plTitulo = pTit1 != undefined ? pTit1 : 'Mensaje';
    this.picloadCallerId = callerId;
    this.plUnaVarias = pUnaVarias;
    //this.plRuta = pRuta1 != undefined ? pRuta1 : 'imgs';
    //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mPl next true');
      this.picload_.next(true);
    })
  }

  notificaPicload(img: string, observ: string) {
    //notifica a todos los suscriptores cuando se toma una foto, envía el callerId para que c/suscriptor decida si es para él.
    //graba dos variables this.plFoto con la img y this.plObserv con la observación para q el suscriptor correcto haga algo
    this.logService.consoleLog('2', 'CS MS notificaPl');
    this.plFoto = img;
    this.plObserv = observ;
    this.picloadCallerId_.next(this.picloadCallerId);
  }

  ocultaPicload() {
    //cierra el picload
    this.logService.consoleLog('2', 'CS MS oPl');
    this.plTitulo = '';
    //this.plRuta = '';
    //pongo el timeout también al cerrar el picload
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS oPl next false');
      this.picload_.next(false);
      this.onPicloadClose_.next();
    })
  }

  //Picshow: muestra un diálogo modal pequeño para ver una foto, talvez hacer zoom y poder eliminarla.
  //Se activa al llamar muestraPicshow(3 parámetros), 
  //se cierra al dar clic en botón Salir
  //recibe parámetros desde la llamada e informa
  psTitulo: string = '';
  //ptRuta:string = '';

  //el observable boolean picshow$ indica si debe verse u ocultarse el diálogo picshow
  private picshow_ = new ReplaySubject<boolean>(1, 100);
  picshow$ = this.picshow_.asObservable();
  //Al llamar a muestraPicshow el Caller envía un id. Al tomarse la foto, notificaPicshow envía el id del Caller
  //en el observable string picshowCallerId$ a todos los suscriptores. Solo el suscriptor q tenga el id correcto 
  //será el Caller, y solo ese suscriptor procesará la imagen como corresponda.
  //En el caso de consultas, el id es el cid de la consulta, solo una consulta llama al picshow en cada instante
  picshowCallerId: string = '';
  private picshowCallerId_ = new ReplaySubject<string>(1, 100);
  picshowCallerId$ = this.picshowCallerId_.asObservable();
  //para cerrar el subscribe q estaba activo al cerrar el pictake
  private onPicshowClose_ = new ReplaySubject<void>(1, 100);
  onPicshowClose$ = this.onPicshowClose_.asObservable();
  //la variable string psFotoUrl contiene la URL de la foto q se acaba de tomar
  psFotoUrl: string = '';
  psObserv: string = '';
  psElim: boolean = false;

  muestraPicshow(callerId: string, pTit1: string, pFotoUrl: string, pObserv: string) {
    //muestra el picshow, los parámetros indican el callerId, título, el Url de la foto y la observ, todos son obligatorios
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mPs');
    this.psTitulo = pTit1 != undefined ? pTit1 : 'Mensaje';
    this.picshowCallerId = callerId;
    this.psFotoUrl = pFotoUrl;
    this.psObserv = pObserv;

    //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mPs next true');
      this.picshow_.next(true);
    })
  }

  notificaPicshow(elim: boolean, observ: string) {
    //notifica a todos los suscriptores cuando se borra una foto o se cambia la observación, envía el callerId 
    //para que c/suscriptor decida si es para él. Graba dos variables para q el suscriptor correcto haga algo:
    //this.psElim (boolean) q indica si elimina o no, y this.psObserv con la observación 
    this.logService.consoleLog('2', 'CS MS notificaPs');
    this.psElim = elim;
    this.psObserv = observ;
    this.picshowCallerId_.next(this.picshowCallerId);
  }

  ocultaPicshow() {
    //cierra el picshow
    this.logService.consoleLog('2', 'CS MS oPs');
    this.psTitulo = '';
    //pongo el timeout también al cerrar el picshow
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS oPs next false');
      this.picshow_.next(false);
      this.onPicshowClose_.next();
    })
  }

  //Preview: muestra un diálogo modal pequeño para ver una previa, talvez hacer zoom y poder eliminarla.
  //Se activa al llamar muestraPreview(3 parámetros), 
  //se cierra al dar clic en botón Salir
  //recibe parámetros desde la llamada e informa
  pvTitulo: string = '';
  //ptRuta:string = '';

  //el observable boolean preview$ indica si debe verse u ocultarse el diálogo preview
  private preview_ = new ReplaySubject<boolean>(1, 100);
  preview$ = this.preview_.asObservable();
  pvPreviaUrl: string = '';
  pvXlsUrl: string = '';
  pvElim: boolean = false;

  muestraPreview(pTit1: string, pPreviaUrl: string, pXlsUrl: string, pElim: boolean) {
    //muestra el preview, los parámetros indican el título y la Url de la previa, todos son obligatorios
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mPv');
    this.pvTitulo = pTit1 != undefined ? pTit1 : 'Vista Previa';
    this.pvPreviaUrl = pPreviaUrl;
    this.pvXlsUrl = pXlsUrl;
    this.pvElim = pElim;

    this.logService.consoleLog('2', 'CS MS mPv next true');
    this.preview_.next(true);
  }

  ocultaPreview() {
    //cierra el preview
    this.logService.consoleLog('2', 'CS MS oPv');
    this.pvTitulo = '';

    this.logService.consoleLog('2', 'CS MS oPv next false');
    this.preview_.next(false);
  }

  //Combo: muestra un diálogo modal pequeño para mostrar una lista al usuario y pedir que elija.
  //Se activa al llamar muestraCombo(array de opciones y otros), 
  //se cierra al dar clic en uno de los botones que llama a ocultaCombo(1 parám)
  //recibe parámetros desde la llamada e informa
  cbPlaceholder: string = '';
  cbOpciones: string[] = [''];
  //cbSubString indica: TRUE: respuesta exacta o fragmento de texto, FALSE: solo respuesta exacta (de la lista de opciones) 
  cbSubString: boolean = true;
  cbRespuesta: string = '';
  cbDatosCampo: CoordCampo;
  cbClase: string;
  cbAcelerar: string = 'N';
  cbOkTexto: string = 'N';
  cbSaltarProxCerrar: boolean = false;
  //contador: number = 1;   //para ver si genera un nuevo valor del observable (ok) o mostraba el mismo (mal)

  private combo_ = new ReplaySubject<boolean>(1, 100);
  combo$ = this.combo_.asObservable();
  private comboRespuesta_ = new ReplaySubject<string>(1, 100);
  comboRespuesta$ = this.comboRespuesta_.asObservable();

  muestraCombo(pPlaceholder: string, pArrOpc: string[], pSubString: boolean, pDatosCampo: CoordCampo, 
    pClase: string, pAcelerar?: string, pOkTexto?: string): Observable<string> {
    //muestra el combo, 
    //recibe el placeholder, el array con las opciones a mostrar, las coord y la clase del campo que llama,
    //pSubString indica: TRUE: respuesta exacta o fragmento de texto, FALSE: solo respuesta exacta (de la lista de opciones)
    //retorna un observable de la respuesta del usr.
    //pAcelerar (opcional) indica si se debe acelerar el combo (no refrescar mientras escribo), p ej si hay miles de pacientes.
    //pOkTexto (opcional) indica si se debe mostrar el botón Ok, q sirve en celulares porque no hay tecla Enter, 
    //    en combos cuando donde es posible buscar un texto no exacto (parcial o con *), como pacientes, cédulas, etc.
    //    pero no cuando la respuesta debe ser exacta, como mes, año, día, S/N, activo/inactivo, etc.
    //    En este caso, el botón Ok se muestra y al clic en él se envía la respuesta (la opción elegida o el texto escrito)
    this.logService.consoleLog('2', 'CS MS mCb Opc1: ' + pArrOpc[1]);
    this.logService.consoleLog('2', 'CS MS mCb place: ' + pPlaceholder);
    this.logService.consoleLog('2', 'CS MS mCb datos: ' + JSON.stringify(pDatosCampo));
    this.logService.consoleLog('2', 'CS MS mCb clase: ' + JSON.stringify(pClase));
    this.cbPlaceholder = pPlaceholder != undefined ? pPlaceholder : '...';
    this.cbOpciones = pArrOpc != undefined ? pArrOpc : [''];
    this.cbSubString = pSubString;
    this.cbDatosCampo = pDatosCampo != undefined ? pDatosCampo : { left: '', top: '', width: '', height: '' };
    this.cbClase = pClase != undefined ? pClase : '';
    this.cbAcelerar = pAcelerar != undefined ? pAcelerar : 'N';
    this.cbOkTexto = pOkTexto != undefined ? pOkTexto : 'N';
    this.cbRespuesta = '';
    //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError, que ocurre porque en
    //una prueba puse un combo al cargar InicioCom. El sitio-usuario (o admin).component.html evalúa la 
    //var local muestraCombo que el .ts puso en false y da inicialmente false, pero enseguida se carga el InicioCom 
    //y pone muestraCombo en true, todo dentro del ciclo normal de carga de la página. El timeout hace que 
    //el cambio a true demore un poco y salga del ciclo de carga, y deja de salir el error.
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mCb next');
      this.combo_.next(true);
    })
    return this.comboRespuesta$;
  }

  ocultaCombo(resp: string, saltarProx: string) {
    //cierra el combo, , el primer parámetro indica la opción elegida, 
    //el segundo puede ser "ok" o un texto que indica que hay que saltar el próximo ocultaDatepick
    this.logService.consoleLog('2', 'CS MS oCb: resp = ' + resp + ', saltarProx = ' + saltarProx + ', próx = ' + this.cbSaltarProxCerrar);
    this.cbRespuesta = resp != undefined ? resp : 'ATENCION!';
    this.cbOpciones = [''];
    if (saltarProx == 'Clic en input, no leer próximo mensaje Combo cerrado') {
      this.cbSaltarProxCerrar = true;
    } else if (saltarProx == 'Combo cerrado con Esc o clic afuera' && this.cbSaltarProxCerrar) {
      //éste es el clic automático en baseOnClick, no hacer nada
      this.cbSaltarProxCerrar = false;
    } else {
      if (saltarProx == 'Combo cerrado con Esc o clic afuera' && !this.cbSaltarProxCerrar) {
        //éste es el clic real afuera, cierro combo y envío this.cbRespuesta = 'Combo cerrado con Esc o clic afuera'
        //si no pongo esto, cuando se da un clic fuera del combo o datepick, el body se queda sin scroll
        this.logService.consoleLog('2', 'CS MS oCb clic fuera');
        this.enableScroll();
        this.cbRespuesta = 'Combo cerrado con Esc o clic afuera';
      }
      this.cbSaltarProxCerrar = false;
      //pongo el timeout también al cerrar el combo
      setTimeout(() => {
        this.logService.consoleLog('2', 'CS MS oCb next false, this.cbRespuesta = ' + this.cbRespuesta);
        this.combo_.next(false);
        if (this.cbRespuesta != '') {
          //genero también el evento de la respuesta
          this.comboRespuesta_.next(this.cbRespuesta); // + this.contador
          //this.contador += 1;
        }
      })
    }
  }

  //Datepick: muestra un diálogo modal pequeño para mostrar un calendario al usuario y pedir que elija una fecha.
  //Se activa al llamar muestraDatepick(Date de fecha elegida y otros), 
  //se cierra al dar clic en una fecha que llama a ocultaDatepick(respuesta tipo Date)
  //recibe parámetros desde la llamada e informa
  //espera la fecha actual en formato yyyy-mm-dd
  dpFechaElegOrig: string = '';
  dpFechaEleg: string = '';
  dpDatosCampo: CoordCampo;
  dpClase: string;
  dpRespuesta: string = '';
  dpSaltarProxCerrar: boolean = false;

  private datepick_ = new ReplaySubject<boolean>(1, 100);
  datepick$ = this.datepick_.asObservable();
  private datepickRespuesta_ = new ReplaySubject<string>(1, 100);
  datepickRespuesta$ = this.datepickRespuesta_.asObservable();

  muestraDatepick(pFechaEleg: string, pDatosCampo: CoordCampo, pClase: string): Observable<string> {
    //muestra el datepick, 
    //recibe la fecha elegida en este momento, las coord y la clase del campo que llama
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mDp fecha: ' + pFechaEleg);
    this.logService.consoleLog('2', 'CS MS mDp datos: ' + JSON.stringify(pDatosCampo));
    this.logService.consoleLog('2', 'CS MS mDp clase: ' + JSON.stringify(pClase));
    this.dpFechaEleg = pFechaEleg != undefined ? pFechaEleg.trim() : '...';
    this.dpFechaElegOrig = this.dpFechaEleg;
    this.dpDatosCampo = pDatosCampo != undefined ? pDatosCampo : { left: '', top: '', width: '', height: '' };
    this.dpClase = pClase != undefined ? pClase : '';
    this.dpRespuesta = '';
    //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mDp next');
      this.datepick_.next(true);
    })
    return this.datepickRespuesta$;
  }

  updateDpFechaEleg(fch: string) {
    this.dpFechaEleg = fch;
  }

  ocultaDatepick(resp: string, saltarProx: string) {
    //cierra el datepick, el primer parámetro indica la fecha elegida, 
    //el segundo puede ser "ok" o un texto que indica que hay que saltar el próximo ocultaDatepick
    this.logService.consoleLog('2', 'CS MS oDp: ' + resp + ', saltarProx: ' + saltarProx + ', próx = ' + this.dpSaltarProxCerrar);
    if (resp == undefined) {
      this.logService.consoleLog('9', 'CS MS oDp: fecha indefinida, se devuelve la fecha original: ' + this.dpFechaEleg)
    }
    this.dpRespuesta = resp != undefined ? resp : this.dpFechaEleg;
    if (saltarProx == 'Clic en input, no leer próximo mensaje Datepick cerrado') {
      this.dpSaltarProxCerrar = true;
    } else if (saltarProx == 'Datepick cerrado con Esc o clic afuera' && this.dpSaltarProxCerrar) {
      //éste es el clic automático en baseOnClick, no hacer nada
      this.dpSaltarProxCerrar = false;
    } else {
      if (saltarProx == 'Datepick cerrado con Esc o clic afuera' && !this.dpSaltarProxCerrar) {
        //éste es el clic real afuera, cierro datepick y envío this.dpRespuesta = 'Datepick cerrado con Esc o clic afuera'
        //si no pongo esto, cuando se da un clic fuera del combo o datepick, el body se queda sin scroll
        this.logService.consoleLog('2', 'CS MS oDp clic fuera');
        this.enableScroll();
        this.dpRespuesta = 'Datepick cerrado con Esc o clic afuera';
      }
      this.dpSaltarProxCerrar = false;
      //pongo el timeout también al cerrar el datepick
      setTimeout(() => {
        this.logService.consoleLog('2', 'CS MS oDp next false, this.dpRespuesta = ' + this.dpRespuesta);
        this.datepick_.next(false);
        if (this.dpRespuesta != '') {
          //genero también el evento de la respuesta
          this.datepickRespuesta_.next(this.dpRespuesta);
        }
      })
    }
  }

  //Dropdown: muestra un diálogo modal pequeño para mostrar un menú al usuario y pedir que elija.
  //Se activa al llamar muestraDropdown(array de opciones y otros), 
  //se cierra al dar clic en uno de los botones que llama a ocultaDropdown(1 parám)
  //recibe parámetros desde la llamada e informa. devuelve el número de opción elegido
  ddPlaceholder: string = '';
  ddOpciones: string[] = [''];
  ddHabilitar: string[] = ['SI'];
  ddRespuesta: number = 999;
  ddDatosCampo: CoordCampo;
  ddClase: string;
  ddSaltarProxCerrar: boolean = false;
  //contador: number = 1;   //para ver si genera un nuevo valor del observable (ok) o mostraba el mismo (mal)

  private dropdown_ = new ReplaySubject<boolean>(1, 100);
  dropdown$ = this.dropdown_.asObservable();
  private dropdownRespuesta_ = new ReplaySubject<number>(1, 100);
  dropdownRespuesta$ = this.dropdownRespuesta_.asObservable();

  muestraDropdown(pPlaceholder: string, pArrOpc: string[], pDatosCampo: CoordCampo, pClase: string, pArrHabilitar?: string[]): Observable<number> {
    //muestra el dropdown, 
    //recibe el placeholder, el array con las opciones a mostrar, las coord y la clase del campo que llama
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mDd Opc1: ' + pArrOpc[1]);
    this.logService.consoleLog('2', 'CS MS mDd place: ' + pPlaceholder);
    this.logService.consoleLog('2', 'CS MS mDd datos: ' + JSON.stringify(pDatosCampo));
    this.logService.consoleLog('2', 'CS MS mDd clase: ' + JSON.stringify(pClase));
    this.ddPlaceholder = pPlaceholder != undefined ? pPlaceholder : '...';
    this.ddOpciones = pArrOpc != undefined ? pArrOpc : [''];
    //El dropdown empieza debajo del menú, por eso quien llama debe enviar el bottom del campo, no el top
    this.ddDatosCampo = pDatosCampo != undefined ? pDatosCampo : { left: '', top: '', width: '', height: '' };
    this.ddClase = pClase != undefined ? pClase : '';
    this.ddRespuesta = 999;
    if (pArrHabilitar != undefined) {
      this.ddHabilitar = pArrHabilitar;
    }

    //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError, que ocurre porque en
    //una prueba puse un dropdown al cargar InicioCom. El sitio-usuario (o admin).component.html evalúa la 
    //var local muestraDropdown que el .ts puso en false y da inicialmente false, pero enseguida se carga el InicioCom 
    //y pone muestraDropdown en true, todo dentro del ciclo normal de carga de la página. El timeout hace que 
    //el cambio a true demore un poco y salga del ciclo de carga, y deja de salir el error.
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS mDd next');
      this.dropdown_.next(true);
    })
    return this.dropdownRespuesta$;
  }

  ocultaDropdown(resp: number, saltarProx: string) {
    //cierra el dropdown, , el primer parámetro indica la opción elegida, 
    //el segundo puede ser "ok" o un texto que indica que hay que saltar el próximo ocultaDatepick
    this.logService.consoleLog('2', 'CS MS oDd: resp = ' + resp + ', saltarProx = ' + saltarProx + ', próx = ' + this.ddSaltarProxCerrar);
    this.ddRespuesta = resp != undefined ? resp : 999;
    this.ddOpciones = [''];
    if (saltarProx == 'Clic en input, no leer próximo mensaje Dropdown cerrado') {
      this.ddSaltarProxCerrar = true;
    } else if (saltarProx == 'Dropdown cerrado con Esc o clic afuera' && this.ddSaltarProxCerrar) {
      //éste es el clic automático en baseOnClick, no hacer nada
      this.ddSaltarProxCerrar = false;
    } else {
      if (saltarProx == 'Dropdown cerrado con Esc o clic afuera' && !this.ddSaltarProxCerrar) {
        //éste es el clic real afuera, cierro dropdown y envío this.ddRespuesta = 'Dropdown cerrado con Esc o clic afuera'
        //si no pongo esto, cuando se da un clic fuera del dropdown o datepick, el body se queda sin scroll
        this.logService.consoleLog('2', 'CS MS oDd clic fuera');
        this.enableScroll();
        this.ddRespuesta = 998;   //Significa: 'Dropdown cerrado con Esc o clic afuera';
      }
      this.ddSaltarProxCerrar = false;
      //pongo el timeout también al cerrar el dropdown
      setTimeout(() => {
        this.logService.consoleLog('2', 'CS MS oDd next false, this.ddRespuesta = ' + this.ddRespuesta);
        this.dropdown_.next(false);
        if (this.ddRespuesta != 999) {
          //genero también el evento de la respuesta
          this.dropdownRespuesta_.next(this.ddRespuesta); // + this.contador
          //this.contador += 1;
        }
      })
    }
  }

  //Selectbox: muestra un diálogo modal pequeño para pedir al usuario que seleccione una respuesta de una lista + Ok o Cancelar.
  //Devuelve Observable<number> el índice del elemento seleccionado si se presionó Ok o 999 si se presionó Cancelar
  //Se activa al llamar muestraSelectbox(2 parámetros), 
  //se cierra al dar clic en Ok o Cancelar, llama a ocultaSelectbox(1 parám)
  //recibe parámetros desde la llamada e informa
  sbTitulo: string = '';
  sbArrOpc: string[] = [];
  sbRespuesta: string = '';
  sbMostrarSiHaySoloUnaOpcion: boolean = true;
  sbMostrarAceptarCancelar: boolean = true;
  //contador: number = 1;   //para ver si genera un nuevo valor del observable (ok) o mostraba el mismo (mal)

  private selectbox_ = new ReplaySubject<boolean>(1, 100);
  selectbox$ = this.selectbox_.asObservable();
  private selectboxRespuesta_ = new ReplaySubject<string>(1, 100);
  selectboxRespuesta$ = this.selectboxRespuesta_.asObservable();

  muestraSelectbox(pTtl: string, pArrOpc: string[], pMostrarSiHaySoloUnaOpcion: boolean, pMostrarAceptarCancelar: boolean): Observable<string> {
    //muestra el selectbox, los parámetros indican lo que se debe mostrar, todos son obligatorios
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mSb');
    this.sbTitulo = pTtl != undefined ? pTtl : 'Mensaje';
    this.sbArrOpc = pArrOpc != undefined ? pArrOpc : [];
    this.sbRespuesta = '';
    this.sbMostrarSiHaySoloUnaOpcion = pMostrarSiHaySoloUnaOpcion != undefined ? pMostrarSiHaySoloUnaOpcion : true;
    this.sbMostrarAceptarCancelar = pMostrarAceptarCancelar != undefined ? pMostrarAceptarCancelar : true;
    if (!this.sbMostrarSiHaySoloUnaOpcion && this.sbArrOpc.length == 1) {
      //en este caso no muestro el form, más bien espero un timeout mínimo y  
      //genero el selectboxRespuesta_.next del observable selectboxRespuesta$
      //para devolver la única opción del sbArrOpc
      setTimeout(() => {
        this.logService.consoleLog('2', 'CS MS mSb no mostrar selectbox, una sola opc y bandera false');
        this.selectboxRespuesta_.next(this.sbArrOpc[0]);
      })
    } else {
      //uso este timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError, que ocurre porque en
      //una prueba puse un selectbox al cargar InicioCom. El sitio-usuario (o admin).component.html evalúa la 
      //var local muestraSelectbox que el .ts puso en false y da inicialmente false, pero enseguida se carga el InicioCom 
      //y pone muestraSelectbox en true, todo dentro del ciclo normal de carga de la página. El timeout hace que 
      //el cambio a true demore un poco y salga del ciclo de carga, y deja de salir el error.
      setTimeout(() => {
        this.logService.consoleLog('2', 'CS MS mSb next true');
        this.selectbox_.next(true);
      })
    }
    return this.selectboxRespuesta$;
  }

  ocultaSelectbox(resp: string) {
    //cierra el selectbox, el único parámetro indica el botón respondido
    this.logService.consoleLog('2', 'CS MS oSb');
    this.sbRespuesta = resp != undefined ? resp : 'ATENCION!';
    this.sbTitulo = '';
    this.sbArrOpc = [];
    //pongo el timeout también al cerrar el selectbox
    setTimeout(() => {
      this.logService.consoleLog('2', 'CS MS oSb next false');
      this.selectbox_.next(false);
      if (resp != '') {
        //genero también el evento de la respuesta
        this.selectboxRespuesta_.next(this.sbRespuesta); // + this.contador
        //this.contador += 1;
      }
    })
  }

  //Placetopay: muestra un diálogo modal con un iframe donde se puede ejecutar el script del lighbox de Placetopay
  //Se activa al llamar muestraPlacetopay(sin parámetros), 
  //se cierra al recibir un evento de cierre
  //recibe parámetros desde la llamada e informa
  //ptRuta:string = '';
  urlPlacetopay: string = '';
  ptpRespuesta: RespuestaPlacetopay = new RespuestaPlacetopay();

  //el observable boolean placetopay$ indica si debe verse u ocultarse el diálogo placetopay
  private placetopay_ = new ReplaySubject<boolean>(1, 100);
  placetopay$ = this.placetopay_.asObservable();
  private placetopayRespuesta_ = new ReplaySubject<RespuestaPlacetopay>(1, 100);
  placetopayRespuesta$ = this.placetopayRespuesta_.asObservable();

  muestraPlacetopay(pUrlPlacetopay): Observable<RespuestaPlacetopay> {
    //muestra el Placetopay LightBox
    //retorna un observable de la respuesta del usr
    this.logService.consoleLog('2', 'CS MS mPpt');
    this.logService.consoleLog('2', 'CS MS mPpt next true');
    this.urlPlacetopay = pUrlPlacetopay;
    //this.ptpRespuesta = new RespuestaPlacetopay();
    this.placetopay_.next(true);
    return this.placetopayRespuesta$;
  }

  ocultaPlacetopay(resp: RespuestaPlacetopay) {
    //cierra el placetopay
    this.urlPlacetopay = '';
    this.logService.consoleLog('2', 'CS MS oPpt');
    this.logService.consoleLog('2', 'CS MS oPpt next false');
    this.placetopay_.next(false);
    if (resp != undefined && resp.type != '') {
      //genero también el evento de la respuesta
      this.placetopayRespuesta_.next(resp);
    }
  }



  /*
  Usado por Combo y Datepick y Drowdown para evitar que se pueda hacer scroll en el form que llama al combo cuando éste es visible
  */
  nivelScroll: string = '';

  enableScrollTotal() {
    this.nivelScroll = 'primer nivel';
    document.body.classList.remove("stop-scrolling");
  }

  disableScroll(nivel?: string) {
    //El nivel sirve para casos en que un elemento llama a otro, por ej. datepick abre combo de meses o años.
    //En ese caso, al cerrar el segundo elemento todavía no quiero que aparezca el scroll, 
    //sino que espere a que termine el primer elemento para mostrar el scroll
    //Por ahora solo manejo dos niveles.
    if (this.nivelScroll != 'disable total') {
      if (nivel == undefined || nivel == 'primer nivel') {
        this.logService.consoleLog('2', 'CS MS disablescr')
        document.body.classList.add("stop-scrolling");
        this.nivelScroll = 'primer nivel';
      } else {
        this.logService.consoleLog('2', 'CS MS disablescr segundo nivel')
        //document.body.classList.add("stop-scrolling");
        this.nivelScroll = 'segundo nivel';
      }
    }
  }

  enableScroll() {
    //Por ahora solo manejo dos niveles.
    if (this.nivelScroll == 'disable total') {
      this.logService.consoleLog('2', 'CS MS enablescr disable total')
    } else if (this.nivelScroll == 'segundo nivel') {
      this.logService.consoleLog('2', 'CS MS enablescr segundo nivel')
      this.nivelScroll = 'primer nivel'
    } else {
      this.logService.consoleLog('2', 'CS MS enablescr')
      document.body.classList.remove("stop-scrolling");
    }
  }

  disableScrollTotal() {
    this.nivelScroll = 'disable total';
    document.body.classList.add("stop-scrolling");
  }

}
